import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true, // needed for httpOnly refresh cookie
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('zq_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshing = null; // singleton promise to avoid multiple simultaneous refreshes

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config;

    // Only attempt refresh for mosque admins with a stored token on 401
    const role = localStorage.getItem('zq_role');
    if (
      err.response?.status === 401 &&
      role === 'mosque' &&
      localStorage.getItem('zq_token') &&
      !original._retried
    ) {
      original._retried = true;

      try {
        if (!refreshing) {
          refreshing = axios.post('/api/auth/mosque/refresh', {}, { withCredentials: true })
            .finally(() => { refreshing = null; });
        }
        const { data } = await refreshing;
        localStorage.setItem('zq_token', data.token);
        original.headers.Authorization = `Bearer ${data.token}`;
        return api(original);
      } catch {
        // Refresh failed — clear session and redirect
        localStorage.removeItem('zq_token');
        localStorage.removeItem('zq_role');
        localStorage.removeItem('zq_mosque');
        localStorage.removeItem('zq_plan');
        window.location.href = '/login';
        return Promise.reject(err);
      }
    }

    // Super admin or non-retried 401
    if (err.response?.status === 401 && localStorage.getItem('zq_token') && !original._retried) {
      localStorage.removeItem('zq_token');
      localStorage.removeItem('zq_role');
      window.location.href = '/login';
    }

    return Promise.reject(err);
  }
);

export default api;
